import { render } from "./BarcodeExport.vue?vue&type=template&id=6d559690"
import script from "./BarcodeExport.vue?vue&type=script&lang=ts"
export * from "./BarcodeExport.vue?vue&type=script&lang=ts"
script.render = render

export default script